import {CoreDataType} from "../../../../common/apis/datatype/DataTypeDefinitionDto";
import {TranslationFunction} from "../../../../store/localization/TranslMessasge";
import {DataTypeTranslationKey} from "./DataTypeTranslationKey";

export class CoreDataTypeFormatter {
    static formatCoreDataType(coreDataType: CoreDataType | string | undefined | null, t: TranslationFunction) {
        if (!coreDataType) {
            return "";
        }
        return t(DataTypeTranslationKey.CORE_DATA_TYPE + "." + coreDataType);
    }
}